import { EntityStatus } from '../../organisations/enums/entity-status.enum';
import { IBusinessInformation } from '../../../../../forms/src/lib/interfaces/business-information.interface';
import { IOrganisation } from '../../organisations/interfaces/organisation.interface';
import { IPaymentContract } from '../../payment-contracts/interfaces/payment-contract.interface';
import { InteractionType } from '../enums/interaction-type.enum';
import { VerificationCapability } from '../enums/verification-capability.enum';

export interface IPointInteraction {
  // API fields
  poiUid?: string;
  altVfiPoiId?: string;
  altPoiId?: string;
  name?: string;
  description?: string;
  type: InteractionType;
  serialNumber?: string;
  verificationCapabilities?: VerificationCapability[];
  pinLengthCapability?: number;
  approvalCodeLength?: number;
  captureCardCapable?: boolean;
  status: EntityStatus;
  entityUid?: string;
  entity?: IOrganisation;
  additionalParameters?: {
    beaconId?: string;
  };
  estateManagementId?: string;

  // Derived fields
  formattedType?: string;
  contractRelationships?: IPaymentContract[];
  businessInformation?: IBusinessInformation;

  contractName?: string;
  printerFormat?: string;
  poiCutoverConfigurationId?: string;
}
